"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _add = _interopRequireDefault(require("date-fns/add"));
var _format = _interopRequireDefault(require("date-fns/format"));
const SCHEDULE_ENDPOINT = process.env.REACT_APP_SCHEDULE_V2;
const NETWORK = process.env.REACT_APP_NETWORK;
const estDateString = new Date().toLocaleString('en-US', {
  timeZone: "America/New_York"
});
const EST_DATE = new Date(estDateString);
const useGetUpcoming = async _ref => {
  let {
    programId,
    programType = 'series'
  } = _ref;
  const getUpcomingAirDates = (0, _react.useCallback)(async (programId, programType) => {
    const typeToParam = new Map([['series', "series_prefix__icontains=".concat(programId)], ['film', "title_code__iexact=".concat(programId)]]);
    const endpoint = "".concat(SCHEDULE_ENDPOINT, "/").concat(NETWORK, "?ordering=start_ts_parse&").concat(typeToParam.get(programType), "&start_date__range=").concat((0, _format.default)(EST_DATE, 'yyyy-MM-dd'), ",").concat((0, _format.default)((0, _add.default)(EST_DATE, {
      days: 14
    }), 'yyyy-MM-dd'), "&limit=20");
    try {
      const response = await fetch(endpoint);
      if (response !== null && response !== void 0 && response.ok) {
        return await response.json();
      } else {
        console.log("An error was returned from fetch. HTTP Response Code: ', ".concat(response === null || response === void 0 ? void 0 : response.status));
      }
    } catch (error) {
      console.log('Fetch failed with error:', error);
    }
  }, []);
  const showAirdates = (0, _react.useMemo)(async () => {
    const response = await getUpcomingAirDates(programId, programType);
    const airdates = response.results.filter(item => item.start_ts_parse * 1000 > EST_DATE.valueOf());
    return await airdates;
  }, [getUpcomingAirDates, programId, programType]);
  return await showAirdates;
};
var _default = exports.default = useGetUpcoming;